module.exports = __webpack_public_path__ + "img/tipo_cdc_prjweb.8287a686.png";